import { object } from "../helpers/object";
import { debug } from "../helpers/debug";
import { services } from "../helpers/service";
import { tpl } from "../helpers/tpl";


class PromoInCategory {

  constructor(module){
    this.MODULE = module;
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    if (!this.DOM_MODULE.length) return;
    var pidVal = this.DOM_MODULE[0].getAttribute('data-js-promo-in-category-tid');
    var activePage = this.DOM_MODULE[0].getAttribute('data-js-promo-in-category-active-page');
    if( pidVal !== null && activePage !== null ){
      this.getCategoryBlockPromo({ tid: pidVal, page: activePage});
    }
    if(debug.DEBUG) console.log('async/promoInCategory.js');
  }

  getCategoryBlockPromo = (data) => {
    return services.use('produitblockpromo', data)
      .then((data) => {
        this.produitBlockPromoSuccess(data)
      })
      .catch(() => {
        this.produitBlockPromoFail()
      });
  };

  produitBlockPromoSuccess = (data) => {
    if (!data.datas.length) return;
  
    data.datas.forEach((element, index) => {
      const html = tpl.get({
        description: element.title,
        title: element.soustitre,
        image: element.image,
        link: element.link,
        classS: element.classS
      }, 'tpl-card-promo');
  
      const prevElement = this.DOM_MODULE[0].querySelectorAll('.c-card__wrapper:not(c-card-promo)');
      const targetIndex = (index + 1) * 4 + index;
      if (prevElement[targetIndex]) {
        prevElement[targetIndex].insertAdjacentHTML('afterend', html);
      }
    });
  }

  produitBlockPromoFail = () => {
    if(debug.DEBUG) console.error('Block promo fail');
  }
}
export default new PromoInCategory('[data-js-component="promo-in-category"]'); 